
export interface Delegati {
  delega_id: string;
  delegante_id: string;
  nome: string;
  cognome: number;
}

export class InfoUser {
  img_photo_file: string;
  limite_prenotazioni: string;
  max_prenotazioni: string;
  account_id: string;
  login: string;
  extname: string;
  descrizione: string;
  email: string;
  nome: string;
  cognome: string;
  id_agenzia: string;
  nome_agenzia: string;
  cellulare: string;
  fax: string;
  is_operatore_agenzia: string;
  is_email_auto_login: string;
  cellulare_notifiche_sms: string;
  password: string;
  last_login: string;
  is_blocked: string;
  is_area_manager: string;
  data_inizio_attivita: string;
  info_struttura: InfoStruttura;
}

export class InfoStruttura {
  agenzia: string;
  id_agenzia_manager: string;
  agenzia_manager: string;
  agenzia_manager_email: string;
  id_regional_manager: string;
  regional_manager: string;
  regional_manager_email: string;
  is_manager_struttura: string;
  is_consulente_struttura: string;
  ha_struttura: string;
}
